import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';
 
function hasBooleanSuccess(body: unknown): boolean {
  return (
    !!body &&
    typeof body === 'object' &&
    !Array.isArray(body) &&
    typeof (body as Record<string, unknown>)['success'] === 'boolean'
  );
}
 
export const responseEnvelopeInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.responseType !== 'json' || !req.url.includes('/api/v2')) {
    return next(req);
  }
 
  return next(req).pipe(
    map(event => {
      if (event instanceof HttpResponse && !hasBooleanSuccess(event.body)) {
        return event.clone({ body: { success: true, data: event.body } });
      }
      return event;
    }),
  );
};
 